import React from 'react';
import UnifiedGallery from '../components/UnifiedGallery';
import useStandardGallery from '../hooks/useStandardGallery';

const April122025Page = () => {
  // Use standardized gallery hook with consistent configuration
  const { getGalleryProps } = useStandardGallery('marco_luz');
  
  return (
      <div className="page-container-wrapper max-width-default padding-default">
        <div className="page-header">
          <h1>
            <i className="fas fa-calendar-day"></i>
            April 12, 2025
          </h1>
          <p>A special day worth remembering</p>
        </div>
        
        <div className="page-content">
          <div className="section">
            <div className="section-header">
              <div className="section-icon">
                <i className="fas fa-star"></i>
              </div>
              <h2>Special Celebration</h2>
            </div>
            <p>
              Welcome to April 12, 2025! This date holds special significance and memories worth preserving. 
              In mid-April, spring is in full bloom - a perfect time for celebrations, new beginnings, and creating lasting memories.
            </p>
            
            <div className="cta-buttons">
              <button className="cta-btn primary">
                <i className="fas fa-calendar-check"></i>
                Mark the Date
              </button>
              <button className="cta-btn secondary">
                <i className="fas fa-heart"></i>
                Share Memories
              </button>
            </div>

            {/* April 12 Gallery */}
            <div className="futbol-gallery-section">
              <UnifiedGallery 
                {...getGalleryProps("April 12, 2025")}
              />
            </div>
          </div>
        </div>
      </div>
  );
};

export default April122025Page;